import { apiBaseUrlAdmin } from "../../../constants/url.constant";
import { DefaultService } from "../../common/services/DefaultService";

export class AdminGroupService extends DefaultService {
    private baseUrl = `${apiBaseUrlAdmin}/group`;

    public RoutePostCreate = () => `${this.baseUrl}/create`;
    public RoutePostCreateOneTime = () => `/${this.baseUrl}/createOneTime`;
}